import { useCallback, useEffect, useState } from 'react';

const STORE = 'gourdex.settings';

const DEFAULTS = {
  lang: 'ht',            // Kreyòl on a first visit, whatever the browser's language; Reglaj changes it
  skin: 'dark',          // 'auto' (follow the device) | 'light' | 'dark'
  voiceLang: 'ht',       // the language the app listens for and answers in (src/shared/speech.mjs)
  voiceId: '',           // the Kreyòl voice; '' = the platform's default
  speaker: '',           // the voice for the other languages; '' = the first on offer
  autoSpeak: true,
  volume: 1,             // the voice: 1 loud, 0.5 quiet, 0 muted (the button beside the cog)
  foreign: 'usd',        // the foreign currency on the front page: 'usd' | 'eur' | 'cad' | 'dop'
  showHtd: false,        // the Haitian-dollar row, always: off, it comes only when asked for
  bareDola: 'htd',       // what an unqualified "dola" means, while the Haitian dollar is shown: 'htd' | 'usd'
};

function load() {
  try {
    return { ...DEFAULTS, ...JSON.parse(localStorage.getItem(STORE)) };
  } catch {
    return DEFAULTS;
  }
}

const THEME_COLOR = { light: '#d2d6f3', dark: '#191532' };   // --app-bg-color of each skin

/** The user's choices, kept in localStorage, with the skin applied to <html>. */
export function useSettings() {
  const [settings, setSettings] = useState(load);

  const update = useCallback((patch) => {
    setSettings((prev) => {
      const next = { ...prev, ...patch };
      try { localStorage.setItem(STORE, JSON.stringify(next)); } catch {}
      return next;
    });
  }, []);

  useEffect(() => {
    const system = window.matchMedia?.('(prefers-color-scheme: dark)');
    const apply = () => {
      const skin = settings.skin === 'auto' ? (system?.matches ? 'dark' : 'light') : settings.skin;
      document.documentElement.dataset.skin = skin;
      document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[skin]);
    };
    apply();
    system?.addEventListener?.('change', apply);
    return () => system?.removeEventListener?.('change', apply);
  }, [settings.skin]);

  useEffect(() => { document.documentElement.lang = settings.lang; }, [settings.lang]);

  return [settings, update];
}
